import axios from "axios";

const buscarProfissoesAPI = async function (entidadeorgaoslug) {
  var profissoes = {}

  console.log("entrou buscarProfissoesAPI")
  try {
      await axios({
        method: 'get',
        url: `http://hmawsap37.grupo.qualicorp/alianca/wp-json/aliancaheadless/v1/profissoes-entidade-orgao/${entidadeorgaoslug}`
      }).then(response =>{
        profissoes = response.data
      })
      .catch(error => {
        profissoes = undefined
        console.log(error)
      })
  } catch (e) {
    console.log(e)
  }

  return profissoes
};

export default buscarProfissoesAPI;
